import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'

import { URL_SERVICIOS_LOCALES, URL_SERVICIOS_AWS,NUBE_AWS, URL_SERVICIOS_AWS_IMAGE } from '../../config/url.servicio'
import { map } from 'rxjs/operators';
@Injectable()
export class GruposProductosProvider {
  token:string

  constructor(public http: Http, private storage: Storage) {
    this.storage.get('token').then((val) => {
      this.token = val
    });
  }

  buscar() {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=gruposProductos`)
    .map((data) => data.json())
  }
  buscarGruposProductosCompaniasId(valor:any) {
    let url = URL_SERVICIOS_LOCALES
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscargruposProductos",
        parameters : {companiasId: valor}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      return this.http.get(`${url}/query?name=buscargruposProductos&companiasId=${valor}`)
      .map((data) => data.json())
    }
  }

  buscarPublicidad(valor:any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: "buscarPublicidad",
      parameters : {companiasId: valor}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  guardar(gruposProducto: any, typeImg: any) {
    if(NUBE_AWS) {
      const url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "dataDynamicCrud",
        parameters : {
                      ...gruposProducto
                    }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
   }
    else {
      var data = new FormData();
      data.append('file', gruposProducto.imagen)
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'authorization': 'Bearer ' + this.token
      })
      let options = new RequestOptions({
        headers: headers
      })

      data.append('codigoGrupoProducto', gruposProducto.codigoGrupoProducto)
      data.append('nombreGrupoProducto', gruposProducto.nombreGrupoProducto)
      data.append('imagen', new Blob([gruposProducto.imagen], {type: typeImg}))
      data.append('companiasId', gruposProducto.companiasId)

      return this.http.post(`${url}/gruposProductos`, data, options)
        .map((data) => data.json())
   }
  }

  guardarImagen(gruposProducto: any, typeImg: any) {
    var data = new FormData();
    data.append('file', gruposProducto.imagen)

    if(NUBE_AWS) {
      let url_servicio_aws_image = URL_SERVICIOS_AWS_IMAGE
      return this.http.post(`${url_servicio_aws_image}/dev/image-upload`, data)
      .map((data) =>  data.json())
   }
    else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'authorization': 'Bearer ' + this.token
      })
      let options = new RequestOptions({
        headers: headers
      })

      data.append('codigoGrupoProducto', gruposProducto.codigoGrupoProducto)
      data.append('nombreGrupoProducto', gruposProducto.nombreGrupoProducto)
      data.append('imagen', new Blob([gruposProducto.imagen], {type: typeImg}))
      data.append('companiasId', gruposProducto.companiasId)

      return this.http.post(`${url}/gruposProductos`, data, options)
        .map((data) => data.json())
   }
  }

  buscardata = async (url_servicio: any, data: any ) => {
    let promise = new Promise(async (resolve,reject) => {
      try {
       return fetch(url_servicio, {
          method: 'POST',
          body: data
        }).then((data)=> {
          console.log('data', data)
          return resolve(data)
        })

      } catch (error) {
        console.log('error', error)
        return reject(error)
      }
    })
    return promise
  }

  editar(gruposProducto, typeImg) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: gruposProducto.name,
        parameters : {...gruposProducto}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'authorization': 'Bearer ' + this.token
    })
    let options = new RequestOptions({
      headers: headers
    })

    var data = new FormData();
    data.append('codigoGrupoProducto', gruposProducto.codigoGrupoProducto)
    data.append('nombreGrupoProducto', gruposProducto.nombreGrupoProducto)
    data.append('gruposProductosId',   gruposProducto.gruposProductosId)
    // verificar si se modifico el gruposProducto
    try {
      if( gruposProducto.imagen.indexOf('http') > -1 ){
        data.append('imagen', gruposProducto.imagen)
      } else {
        data.append('imagen', new Blob([gruposProducto.imagen], {type: typeImg}))
      }
    } catch (error) {
      data.append('imagen', new Blob([gruposProducto.imagen], {type: typeImg}))
    }

    data.append('companiasId', gruposProducto.companiasId)

    return this.http.put(`${url}/gruposProductos`, data, options)
      .map((data) => data.json())
   }
  }

  eliminar(gruposProducto: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: gruposProducto.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          gruposProductosId : gruposProducto.gruposProductosId,
          nombreTabla: "gruposProductos"
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })

    return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&gruposProductosId=${gruposProducto.gruposProductosId}&nombreTabla=gruposProductos`, options)
  }
  }

  eliminarPublicidad(publicidad: any) {

      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "dataDynamicCrud",
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          publicidadId : publicidad.publicidadId,
          nombreTabla: "publicidad"
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);

  }

  // guardarArchivoDescargas(archivo: any, typeImg: any) {
  //   var data = new FormData();
  //   data.append('file', archivo);

  //   // Aquí sigue usando el endpoint para subir archivos
  //   let url_servicio_aws_file = URL_SERVICIOS_AWS_IMAGE;  // Asegúrate de tener el URL correcto para archivos
  //   return this.http.post(`${url_servicio_aws_file}/dev/file-upload`, data)
  //     .map((data) => data.json());  // Asumiendo que la respuesta sea JSON
  // }
  guardarArchivoDescargas(archivo: any,a:any) {
    let url_servicio_aws_file = URL_SERVICIOS_AWS_IMAGE;

    let formData = new FormData();
    formData.append('file', archivo);  // Aquí agregas el archivo al FormData

    return this.http.post(`${url_servicio_aws_file}/dev/file-upload`, formData)
      .pipe(
        map((data: any) => data)  // Maneja la respuesta como JSON
      );
  }

  guardarImagenUnica(data: any) {
    let url_servicio_aws_image = URL_SERVICIOS_AWS_IMAGE
    return this.http.post(`${url_servicio_aws_image}/dev/image-upload`, data)
    .map((data) =>  data.json())

  }


}



// WEBPACK FOOTER //
// ./src/providers/gruposProductos/gruposProductos.ts